/**
  © BlockyApps. You are permitted to use this content within your store. Redistribution or use in any other application is strictly prohibited. 
  Unauthorized copying, distribution, or reproduction in any form will result in legal action.
**/
if (!customElements.get('blocky-video')) {
  customElements.define(
    'blocky-video',
    class BlockyVideo extends HTMLElement {
      constructor() {
        super();
        this.video = this.querySelector('video');

        if (this.video) {
          this.video.addEventListener('waiting', this.showSpinner.bind(this));
          this.video.addEventListener('canplaythrough', this.hideSpinner.bind(this));
          this.video.addEventListener('error', this.hideSpinner.bind(this));
        }

        if (this.classList.contains('blocky-video-manual')) {
          // Manual videos (autoplay == false) – use play button / click
          this.video.addEventListener('click', (e) => this.onClick());
          const button = this.querySelector('.blocky-video-play-button');
          if (button) {
            button.addEventListener('click', (e) => this.onClick());
          }
        } else {
          // Auto videos (default Blocky behaviour)
          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(
              this.handleIntersection.bind(this),
              { root: null, rootMargin: '0px', threshold: 0.05 }
            );
            this.observer.observe(this);
          } else {
            // Fallback for browsers that don't support IntersectionObserver
            for (const source of this.video.querySelectorAll('source[data-src]')) {
              source.setAttribute('src', source.getAttribute('data-src'));
              source.removeAttribute('data-src');
            }
            this.video.load();
          }

          // IMPORTANT: removed the old "pause" and "canplay" auto-replay listeners
          // that forced videos to start again after being paused.
          //
          // this.video.addEventListener("pause", (event) => {
          //   if (event.target.paused) event.target.play()
          // })
          // this.video.addEventListener("canplay", (event) => {
          //   if (event.target.paused) event.target.play()
          // })
        }
      }

      handleIntersection(entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            for (const source of this.video.querySelectorAll('source[data-src]')) {
              source.setAttribute('src', source.getAttribute('data-src'));
              source.removeAttribute('data-src');
            }
            this.video.load();
            this.video.play();
            this.observer.disconnect();
          }
        });
      }

      onClick() {
        const button = this.querySelector('.blocky-video-play-button');
        if (this.video.paused === true) {
          this.showSpinner();
          const playPromise = this.video.play();
          playPromise
            .then(() => {
              this.hideSpinner();
            })
            .catch((error) => {
              this.hideSpinner();
            });
          this.video.classList.add('blocky-video-playing');
          if (button) {
            button.classList.add('blocky-hidden');
          }
        } else {
          this.video.pause();
          this.video.classList.remove('blocky-video-playing');
          if (button) {
            button.classList.remove('blocky-hidden');
          }
        }
      }

      showSpinner() {
        if (this.video) {
          this.video.classList.add('loading');
        }
      }

      hideSpinner() {
        if (this.video) {
          this.video.classList.remove('loading');
        }
      }
    }
  );
}

// Global logic: only one auto video (non-manual) plays at a time,
// and it only plays when in view.
document.addEventListener('DOMContentLoaded', function () {
  // All Blocky video wrappers that are NOT "manual" (sound/UGC) ones
  const wrappers = Array.prototype.slice.call(
    document.querySelectorAll('blocky-video:not(.blocky-video-manual)')
  );

  if (!('IntersectionObserver' in window) || wrappers.length === 0) {
    return;
  }

  const videos = wrappers
    .map(function (wrap) {
      return wrap.querySelector('video');
    })
    .filter(Boolean);

  // Ensure these auto videos are muted for autoplay safety
  videos.forEach(function (video) {
    video.muted = true;
  });

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        const video = entry.target;

        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          // Pause all other videos
          videos.forEach(function (v) {
            if (v !== video) {
              v.pause();
            }
          });

          // Play this one
          if (video.paused) {
            video.play().catch(function () {
              // ignore autoplay errors
            });
          }
        } else {
          // Out of view -> pause
          video.pause();
        }
      });
    },
    {
      threshold: [0, 0.6, 1],
    }
  );

  videos.forEach(function (video) {
    observer.observe(video);
  });
});
